module.exports = __webpack_public_path__ + "static/media/benchTube.7aeeb930.svg";